﻿window.cObjetFormulaireReponseMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetTableUpdateLib = function () { return ["Formulaire_reponse"] }

    this.mGetLibBase = function () { return "Réponse Formulaire"; }
    this.mGetAttributBase = function () { return "le" }
    this.mGetNewLib = function () { return "Nouvelle réponse Formulaire"; }
    this.mGetLib1 = function (option) {
        if (typeof option == 'undefined') option = {}
        if (typeof option.dataTemplate != 'undefined') {
            return mGetLib1(option.dataTemplate)
        } else {
            if (typeof objet.data == 'undefined') {
                if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack("") }
                else { return "" }
            } else {
                var txt = ""
                if (Me.objet.cle() == null) {
                    if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
                    else { return txt }
                } else {
                    Me.objet.bddRef.mAjaxCall({
                        command: "getlstdatavirtualgrid",
                        data: [{ id_table: Me.objet.mGetTable().id_table, id: Me.objet.cle() }],
                        async: (typeof option.callBack != 'undefined')
                    }, function (data) {
                        var dataTemplate = ((typeof data.lstdatatemplate == "undefined") ? null : data.lstdatatemplate[0])
                        txt = ((dataTemplate == null) ? "" : mGetLib1(dataTemplate))
                    })
                    return txt
                }
            }
        }

        function mGetLib1(dataTemplate) {
            var txt = ""
            if (dataTemplate.id_table_destinataire) {
                if (dataTemplate.nom_str && dataTemplate.nom_str.length > 0) txt += dataTemplate.nom_str
                if (dataTemplate.con_nom && dataTemplate.con_nom.length > 0) txt += (txt.length > 0 ? " " : "") + dataTemplate.con_nom
                if (dataTemplate.con_prenom && dataTemplate.con_prenom.length > 0) txt += (txt.length > 0 ? " " : "") + dataTemplate.con_prenom
                if (txt.length == 0) {
                    txt = "(Contact sans nom)"
                }
            } else {
                txt = "(Aucun contact)"
            }
            txt += " &bull; " + dataTemplate.objet_formulaire
            if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
            else { return txt }
        }
        //var txt = ""
        //if (typeof objet.data != 'undefined') { txt = ((objet.data.nom) ? objet.data.nom : "(aucun nom pour le Formulaire)") }
        //else {
        //    txt = "Réponse Formulaire"
        //}
        //if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        //else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i style='position:relative' class='fafa fafa-formulaire' title='Réponse Formulaire'><i class='fas fa-reply dx-theme-accent-as-text-color' style='position:absolute;bottom:-2px;right:-2px;font-size:60%;'></i></i>");
    }


    this.mGetItemTemplateHeight = function (type) {
        return 55
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();

    }

    this.mGetNomFromTemplate = function (dataTemplate) {
        return "Nouvel réponse Formulaire"
    }
    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {

        if (dataTemplate.vue == "0") {
            contentElement.closest(".divtemplate").css("opacity", "1")
            contentElement.closest(".divtemplate").css("box-shadow", "0 0 5px 0 #ffffff")
            if (objet.bddRef.theme.contains(".light")) {
                contentElement.closest(".divtemplate").css("box-shadow", "0 0 5px 0 #000000")
            }
        } else {
            contentElement.closest(".divtemplate").css("opacity", "0.7")
        }

        var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)

        //var $TdNomFormulaire = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;font-weight:bold;'></td>").appendTo($Tr)
        //$TdNomFormulaire.text(dataTemplate.objet_formulaire)

        var $TdFinalise = $("<td style='width:40px;font-size:140%;'></td>").appendTo($Tr)
        if (dataTemplate.finalise == "0") {
            var $icone = $("<i class='fas fa-circle-half-stroke' style='color:red;'></i>").appendTo($TdFinalise)
            $TdFinalise.attr("title", "L'internaute n'a pas validé le formulaire.<br/>(il n'a pas cliqué sur le bouton 'valider').")
        } else {
            var $icone = $("<i class='fas fa-circle' style='color:green;'></i>").appendTo($TdFinalise)
            $TdFinalise.attr("title", "L'internaute a validé le formulaire.<br/>(soit il a cliqué sur le bouton 'valider' ou il n'y a aucun champ de saisie sur votre formulaire).")
        }
        $("<span> &bull; </span>").appendTo($TdFinalise)

        //var $TdVue = $("<td style='width:40px;font-size:140%;'></td>").appendTo($Tr)
        //if (dataTemplate.vue == "0") {
        //    $("<i class='fas fa-eye-slash state-hover' style='color:orange'></i>").appendTo($TdVue)
        //    $TdVue.attr("title", "Vous n'avez pas encore vu cette réponse au formulaire.<br/>Cliquez pour le marquer comme vu.")
        //} else {
        //    $("<i class='fas fa-eye state-hover' style='color:green'></i>").appendTo($TdVue)
        //    $TdVue.attr("title", "Vous avez vu cette réponse au formulaire.<br/>Cliquez pour le marquer comme non vu.")
        //}
        //$TdVue.on("click", function (e) {
        //    e.stopPropagation()
        //    var obj = objet.bddRef.getObjet("formulaire_reponse", dataTemplate.id_formulaire_reponse)
        //    obj.data.vue = (obj.data.vue == "0" ? "1" : "0")
        //    obj.mSaveChamp("vue")
        //})
        //$("<span> &bull; </span>").appendTo($TdVue)

        var $TdTraite = $("<td style='width:40px;font-size:140%;'></td>").appendTo($Tr)
        if (dataTemplate.traite == "0") {
            var $icone = $("<i class='fas fa-thumbs-down' style='color:red'></i>").appendTo($TdTraite)
            $TdTraite.attr("title", "Vous n'avez pas encore traité cette réponse au formulaire.<br/>Cliquez pour le marquer comme traité.")
        } else {
            var $icone = $("<i class='fas fa-thumbs-up' style='color:green'></i>").appendTo($TdTraite)
            $TdTraite.attr("title", "Vous avez traité cette réponse au formulaire.<br/>Cliquez pour le marquer comme traité.")
        }
        //$TdTraite.on("click", function (e) {
        //    e.stopPropagation()
        //    var obj = objet.bddRef.getObjet("formulaire_reponse", dataTemplate.id_formulaire_reponse)
        //    obj.data.traite = (obj.data.traite == "0" ? "1" : "0")
        //    obj.mSaveChamp("traite")
        //})
        $("<span> &bull; </span>").appendTo($TdTraite)

        var $TdNomFormulaire = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;font-weight:bold;'></td>").appendTo($Tr)

        var nbSaisie = 0
        var dataJson = JSON.parse(dataTemplate.json)
        if (dataJson.lst && dataJson.lst.length > 0) {
            nbSaisie = dataJson.lst.length
        }
        var $Saisie = $("<span><span style='font-size:120%;opacity:" + (nbSaisie == 0 ? 0.5 : 1) + ";'>" + nbSaisie + "<i class='fas fa-square-pen'></i></span><span> &bull; </span></span>").appendTo($TdNomFormulaire)
        $Saisie.attr("title", nbSaisie + " réponse" + (nbSaisie > 1 ? "s" : ""))
        $("<span/>").text(dataTemplate.objet_formulaire + "").appendTo($TdNomFormulaire)

        var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $TdNom = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;font-weight:bold;'></td>").appendTo($Tr)
        var txt = ""
        if (dataTemplate.id_table) {
            if (dataTemplate.nom_str && dataTemplate.nom_str.length > 0) txt += dataTemplate.nom_str
            if (dataTemplate.con_nom && dataTemplate.con_nom.length > 0) txt += (txt.length > 0 ? " " : "") + dataTemplate.con_nom
            if (dataTemplate.con_prenom && dataTemplate.con_prenom.length > 0) txt += (txt.length > 0 ? " " : "") + dataTemplate.con_prenom
            if (txt.length == 0) {
                txt = "(Contact sans nom)"
                $TdNom.css("font-weight", "normal")
            }
        } else {
            txt = "(Aucun contact lié à cette réponse)"
            $TdNom.css("font-weight", "normal")
        }
        $TdNom.text(txt)

        //var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        //var $Tr = $("<tr/>").appendTo($Table)


        //var $TdNom = $("<td style='width:20%;text-overflow:ellipsis;overflow:hidden;font-weight:bold;'></td>").appendTo($Tr)
        //if (dataTemplate.complete == "0") {
        //    $TdNom.text("INCOMPLET")
        //    $TdNom.css("color", "red")
        //    $Table.css("text-decoration", "line-through")
        //    $Table.css("opcity", "0.8")
        //} else {
        //    $TdNom.text("COMPLET")
        //    $TdNom.css("color", "green")
        //}

        //var $TdNom = $("<td style='width:50%;text-overflow:ellipsis;overflow:hidden;font-weight:bold;'></td>").appendTo($Tr)
        //var txt = ""
        //if (dataTemplate.id_table_destinataire) {
        //    if (dataTemplate.nom_str && dataTemplate.nom_str.length > 0) txt += dataTemplate.nom_str
        //    if (dataTemplate.con_nom && dataTemplate.con_nom.length > 0) txt += (txt.length > 0 ? " " : "") + dataTemplate.con_nom
        //    if (dataTemplate.con_prenom && dataTemplate.con_prenom.length > 0) txt += (txt.length > 0 ? " " : "") + dataTemplate.con_prenom
        //    if (txt.length == 0) {
        //        txt = "(Contact sans nom)"
        //        $TdNom.css("font-weight", "normal")
        //    }
        //} else {
        //    txt = "(Aucun contact)"
        //    $TdNom.css("font-weight", "normal")
        //}
        //$TdNom.text(txt)

    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus, option) {
        $("<span style='' title='Répondu le " + dataPlus.dcr.toFrenchDateTime() + "'><i class='fas fa-reply dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
    }

    this.isPopupFullScreen = false
    //this.mShowPopup = function (option) {
    //    if (typeof option == 'undefined') option = {}
    //    option.fullScreen = true
    //    page.mAddPopup(objet.data, option)
    //}
    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        var dxCtrl = $("<div style='height:100%;width:100%;'/>").appendTo(contentElement).dxCtrlContentFormulaireReponse({
            bddCtrl: objet.bddRef,
            dataFormulaireReponse: objet.data,
            optionPopup: option
        }).dxCtrlContentFormulaire("instance")
    }

    this.mGetWidthPopup = function () { return 700 }
    this.mGetFullScreenPopup = function () { return false }

    this.mGetPopupPositionWidthHeight = function () {
        return {
            width: "calc(100% - 60px)",
            maxWidth: "calc(100% - 60px)",
            height: "calc(100% - 90px)",
            maxHeight: "calc(100% - 50px)",
            position: {
                my: "right top",
                at: "right top",
                of: "body",
                offset: { x: -30, y: 65 }
            }
        }
    }

}